import React, { useEffect, useState } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import {
  FormattedDate as IntlFormattedDate,
  FormattedRelativeTime,
} from 'react-intl';
import { selectUnit } from '@formatjs/intl-utils';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const propertyTypes = {
  value: PropTypes.string,
};

const incrementableUnits = new Set([
  'second',
  'minute',
  'hour',
]);

type FormattedDateProperties = InferProps<typeof propertyTypes>;

const FormattedDate = ({ value } : FormattedDateProperties) => {
  const [postedRecently, setPostedRecently] = useState<boolean>(false);

  const dayJsValue = dayjs(value);

  useEffect(() => {
    if (value) {
      const dayAgo = dayjs().subtract(1, 'day');
      setPostedRecently(dayJsValue.isAfter(dayAgo));
    }
  }, [value, dayJsValue]);

  if (typeof value !== 'string') {
    return null;
  }

  if (postedRecently) {
    const { value: relativeValue, unit } = selectUnit(dayJsValue.toDate());

    return (
      <FormattedRelativeTime
        value={relativeValue}
        unit={unit}
        updateIntervalInSeconds={incrementableUnits.has(unit) ? 1 : undefined}
      />
    );
  }

  return (
    <IntlFormattedDate
      value={value}
      year="numeric"
      month="short"
      day="numeric"
    />
  );
};

FormattedDate.propTypes = propertyTypes;

export default FormattedDate;
